import AppHeader, { IAppHeaderProps } from "./AppHeader";
import { withRouter } from "react-router-dom";

export default withRouter<IAppHeaderProps, any>(AppHeader);
